/**
 * AI Command Center - Constants and Configuration
 * 
 * Shared constants, icons, colors, and labels used across
 * Command Center components.
 */
import { 
  Wrench, Settings, DollarSign, Eye, Zap 
} from "lucide-react";

// Agent icon mapping
export const AgentIcons = {
  tech: Wrench,
  operations: Settings,
  finance: DollarSign,
};

// Agent emoji avatars
export const AgentAvatars = {
  tech: "👨‍💻",
  operations: "👨‍🍳",
  finance: "👩‍💼",
};

// Agent display names
export const AgentNames = {
  tech: "Alejandro",
  operations: "Santiago",
  finance: "Simone",
};

// Priority badge colors
export const PriorityColors = {
  critical: "bg-red-500/15 text-red-400 border-red-500/30",
  high: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  medium: "bg-blue-500/15 text-blue-400 border-blue-500/30",
  low: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};

// Task status colors
export const StatusColors = {
  pending: "bg-yellow-500/15 text-yellow-400",
  analyzing: "bg-blue-500/15 text-blue-400",
  suggested: "bg-purple-500/15 text-purple-400",
  approved: "bg-cyan-500/15 text-cyan-400",
  executed: "bg-green-500/15 text-green-400",
  failed: "bg-red-500/15 text-red-400",
  dismissed: "bg-slate-500/15 text-slate-400",
};

// Agent mode labels
export const ModeLabels = {
  observer: { label: "Observador", icon: Eye, color: "text-blue-400" },
  executor_controlled: { label: "Executor", icon: Zap, color: "text-amber-400" },
};

// Auto-repair result colors
export const RepairResultColors = {
  success: "bg-green-500/15 text-green-400 border-green-500/30",
  failed: "bg-red-500/15 text-red-400 border-red-500/30",
  partial: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  skipped: "bg-slate-500/15 text-slate-400 border-slate-500/30",
};

// Chart colors
export const CHART_COLORS = {
  success: "#22c55e",
  failure: "#ef4444",
  escalated: "#f59e0b",
  total: "#3b82f6",
  successRate: "#10b981",
};

// Agent chart colors
export const AGENT_COLORS = {
  Alejandro: "#8b5cf6",
  Santiago: "#f97316",
  Simone: "#06b6d4",
};

// Alert severity colors
export const AlertSeverityColors = {
  critical: "bg-red-500/15 text-red-400 border-red-500/30",
  warning: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  info: "bg-blue-500/15 text-blue-400 border-blue-500/30",
};

// Alert type labels
export const AlertTypeLabels = {
  system_health: "Sistema",
  performance: "Performance",
  anomaly: "Anomalia",
  threshold: "Limite",
  integration: "Integracao",
};

// Utility functions
export const formatTime = (isoString) => {
  if (!isoString) return "-";
  const date = new Date(isoString);
  return date.toLocaleString("pt-BR", { 
    day: "2-digit", 
    month: "2-digit", 
    hour: "2-digit", 
    minute: "2-digit" 
  });
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
};

export const getAgentName = (agent) => AgentNames[agent] || agent;
export const getAgentAvatar = (agent) => AgentAvatars[agent] || "🤖";
